import React, { useState } from "react";
import { CommandBarButton, Aside } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { ImportArchiveBucketForm } from "./ImportArchiveBucketForm";

export const ImportArchiveBucketButton: React.VFC = () => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            <CommandBarButton onClick={openAside} text="Import" icon="Add" />
            <Aside
                type="form"
                headerText="Import archive bucket"
                isOpen={isAsideOpen}
                onDismiss={closeAside}
                isLightDismiss={true}
            >
                <ImportArchiveBucketForm onSubmit={closeAside} onCancel={closeAside} />
            </Aside>
        </AuthorizationWrapper>
    );
};
